import type { GaApp } from '~/modules/app'

import { MainService } from './main.service'
import { RegisterService } from './register.service'

export const services = (gaApp: GaApp) => ({
  main: new MainService(gaApp),
  register: new RegisterService(gaApp),
})
